import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

import { TGetChatbotFiltersMicrofrontendModel, TGetChatbotFiltersMicrofrontendResponse, IMappers } from './types';

const defaultConfig: TGetChatbotFiltersMicrofrontendModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'mobile-filters-frontend',
  pathApi: '/v1/get-chatbot-filters-microfrontend/',
  responseContentType: 'json',
} as TGetChatbotFiltersMicrofrontendModel;

function createGetChatbotFiltersMicrofrontendModel(): TGetChatbotFiltersMicrofrontendModel {
  return defaultConfig;
}

export interface IGetChatbotFiltersMicrofrontendOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
}

async function fetchGetChatbotFiltersMicrofrontend<TResponse200>({
  httpApi,
  config,
  mappers,
}: IGetChatbotFiltersMicrofrontendOptions<TResponse200>): Promise<
  TResponse200 | TGetChatbotFiltersMicrofrontendResponse
> {
  const { response, statusCode, headers } = await httpApi.fetch(createGetChatbotFiltersMicrofrontendModel(), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response);
    }
  }

  return { response, statusCode, headers } as TGetChatbotFiltersMicrofrontendResponse;
}

export { defaultConfig, createGetChatbotFiltersMicrofrontendModel, fetchGetChatbotFiltersMicrofrontend };
